import React from 'react';
import MotifNav from '@ey/canvascoreservices/MotifNav';
import {labels} from '../../util/uiconstants';
import styled from 'styled-components';

export default function TopBarNavServer(props) {
	const verifyAdminToolUrl = (path) => {
		path = path !== null ? path.split('/') : null;
		if (path !== null && path.length > 1 && path[1].toLowerCase() === 'admin') {
			return true;
		}
		return false;
	};

	return (
		<StyledServerMotifNav className="server-nav">
			<MotifNav
				applicationName={
					verifyAdminToolUrl(props.location || null)
						? labels.adminTool
						: labels.canvas
				}
				copyrightMessage={labels.copyrightMessage}
				showMoreMenuOptions={false}
				showSelectorDropdown={false}
				showIconLinks={false}
				showNotifications={false}
				showSettings={false}
				showAvatar={false}
				showSearchBox={false}
				disableLogo={false}
				isServerRender={true}
			></MotifNav>
		</StyledServerMotifNav>
	);
}

TopBarNavServer.displayName = 'TopBarNavServer';

const StyledServerMotifNav = styled.section`
	width: 100%;
	.motif-header {
		display: flex;
		background: #ffffff;
		color: #2e2e38;
		padding: 0.4285714286rem 0.7142857143rem;
		z-index: 100;
		height: 4rem;
		border-radius: 0;
		border-style: solid;
		border-width: 0 0 0.07142857143rem 0;
		border-color: #e6e6e9;
		border-bottom: 0.07142857143rem solid #e6e6e9;
		background-color: #f9f9fe;
		justify-content: space-between;
		align-items: center;
		min-width: max-content;
		max-width: 100%;
		gap: 0.5714285714rem;
		.motif-header-container {
			display: flex;
			justify-content: center;
			width: 100%;
			.motif-header-top {
				max-width: 2048px;
				display: flex;
				justify-content: flex-start;
				gap: 0.5714285714rem;
				flex-direction: row;
				align-content: center;
				align-items: center;
				width: 100%;
				height: 3.8571428571rem;
				.motif-header-left {
					display: flex;
					justify-content: flex-start;
					align-items: baseline;
					gap: 0.28572rem;
					margin-left: 0 !important;
					.motif-header-logo {
						width: 2.8571428571rem;
						min-width: 2.8571428571rem;
						height: 2.8571428571rem;
						box-sizing: border-box;
						display: flex;
						justify-content: center;
						align-items: center;
						border-color: transparent;
						border-style: none;
						border-width: 0;
						border-radius: 0.1785714286rem;
						background-color: transparent;
						margin-left: 2.71429rem;
						.motif-icon::before {
							width: 2.14286rem !important;
							height: 2.14286rem !important;
							border-radius: 0.1785714286rem !important;
							background: url(data:image/svg+xml;base64,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)
								no-repeat center center !important;
							background-size: contain !important;
						}
					}
					.motif-header-app-name {
						font-family: ey_interstate;
						font-weight: 400;
						color: #2e2e38;
						font-size: 1.4286rem;
						line-height: 2rem;
						gap: 0.5714285714rem;
						width: max-content;
						margin-bottom: 0.0714285714rem;
						white-space: nowrap;
						overflow: visible;
						text-overflow: ellipsis;
						padding-right: 0.8571428571rem;
						display: flex;
						align-items: center;
					}
				}
			}
		}
	}
`;
